// South Indian Chart Constants
export const ZODIAC_SIGNS = [
  'Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo',
  'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces'
];

export const PLANETS = [
  'Sun', 'Moon', 'Mars', 'Mercury', 'Jupiter', 'Venus', 'Saturn', 'Rahu', 'Ketu'
];

// House positions in South Indian chart (diamond/rhombus shape)
// 1-12 representing the 12 houses
export const HOUSE_POSITIONS = {
  1: { x: 50, y: 80 },      // Bottom right
  2: { x: 70, y: 70 },      // Right
  3: { x: 80, y: 50 },      // Right upper
  4: { x: 70, y: 30 },      // Upper right
  5: { x: 50, y: 20 },      // Top
  6: { x: 30, y: 30 },      // Upper left
  7: { x: 20, y: 50 },      // Left upper
  8: { x: 30, y: 70 },      // Left
  9: { x: 50, y: 80 },      // Bottom left (same as 1 conceptually, adjusted)
  10: { x: 70, y: 70 },     // Right lower
  11: { x: 80, y: 50 },     // Right
  12: { x: 70, y: 30 }      // Upper right
};

// Planet symbols for display
export const PLANET_SYMBOLS = {
  'Sun': '☀️',      // Sun emoji
  'Moon': '🌙',     // Moon emoji
  'Mars': '♂',      // Mars/Male symbol
  'Mercury': '☿',   // Mercury symbol
  'Jupiter': '♃',   // Jupiter symbol
  'Venus': '♀',     // Venus/Female symbol
  'Saturn': '♄',    // Saturn symbol
  'Rahu': '☊',      // Dragon's Head/North Node
  'Kethu': '☋',      // Dragon's Tail/South Node
  'Lagnam': 'AS'    // Ascendant
};

// Colors for different planets
export const PLANET_COLORS = {
  'Sun': '#FDB813',
  'Moon': '#c0bcbcff',
  'Mars': '#d02b2bff',
  'Mercury': '#4CAF50',
  'Jupiter': '#9C27B0',
  'Venus': '#3fbdceff',
  'Saturn': '#795548',
  'Rahu': '#03057eff',
  'Kethu': '#070808ff',
  'Lagnam': '#2196F3'
};
